<div class="container">
  
  <div class="row">
    <!-- logo -->
    <div class="col my-auto"><a [routerLink]="['/']"><img src="assets/images/logo-color.svg" alt="logo" class="logo"></a></div>
  </div>

  <mat-divider></mat-divider>
</div>
